export class LetterAnnuity {
    
    public id: string = "0";
    public annuity_id: string;
    public name: string;
    public subject: string;
    public text: string;
    public image: string;
    public created: Date;
    public deleted: boolean;

    constructor() {}
}
